import { makePropertySelector } from 'store/utils';

const getPropertySelector = makePropertySelector('geoDiscount');

export const getBillingCountry = getPropertySelector('billingCountry');
export const getCookieCountry = getPropertySelector('cookieCountry');
export const getCurrentGeoDiscount = getPropertySelector('currentGeoDiscount');
export const getIsAutoApplied = getPropertySelector('isAutoApplied');
export const getIsValidating = getPropertySelector('isValidating');
